import './Accordion.css';
import pistol from '../../../../images/pistol.png';
import accordionImgBackground from '../../../../images/accordeonImg.png';
import { Avatar } from '../../../../components/Avatar/Avatar';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { User } from '../../../../components/Header/elements/User/User';
import { Border } from '../../../../components/Border/Border';
import { AccordionActiveContainer } from '../AccordionActiveContainer/AccordionActiveContainer';

export const Accordion = ({ setIsInventoryOpen }: { setIsInventoryOpen: Dispatch<SetStateAction<boolean>> }) => {
    const [roomOpen, isRoomOpen] = useState(false);
    const [gameStart, isGameStart] = useState(false);
    const toogleRoom = () => {
        if (roomOpen) {
            isRoomOpen(false);
            setIsInventoryOpen(false);
        }
        if (!roomOpen) {
            isRoomOpen(true);
        }
    };

    const x = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        if (roomOpen) {
            setIsInventoryOpen(true);
        }
        if (!roomOpen) {
            isRoomOpen(true);
            setIsInventoryOpen(true);
        }
    };
    return (
        <>
            <div onClick={toogleRoom} className={`${roomOpen ? 'accordion accordion_active' : 'accordion'}`}>
                <div className="accordion__users-container">
                    <div className="accordion__user">
                        <Avatar />
                        <span className="accordion__user-text">42.85%</span>
                    </div>
                    <button onClick={x} className="accordion__add-user">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                            <g fill="none" opacity=".6">
                                <circle cx="11.92" cy="11.92" r="10" />
                                <path
                                    fill="#F1F1F1"
                                    d="M16.92 10.92h-3a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2z"
                                />
                            </g>
                        </svg>
                    </button>
                </div>
                <div className="accordion__container-skin">
                    <img src={pistol} alt="" className="accordion__img" />
                    <img src={pistol} alt="" className="accordion__img" />
                    <img src={pistol} alt="" className="accordion__img" />
                </div>
                <div>
                    <span className="accordion__line-text">Банк</span>
                    <span className="accordion__money">2560.85 р.</span>
                    <span className="accordion__line-text accordion__line-text_my">
                        Ставка <span className="accordion__line-text-money"> 256.85 р.</span>
                    </span>
                    <img src={accordionImgBackground} alt="" className="accordion__background" />
                </div>
            </div>
            {roomOpen && <AccordionActiveContainer setIsInventoryOpen={setIsInventoryOpen} />}
        </>
    );
};
